export default {
  cryptoBalanceAlerts: {
    display: 'flex',
    marginBottom: 36,
    height: 135,
    alignItems: 'center'
  },
  cryptoBalanceAlertsForm: {
    width: 222,
    marginRight: 32
  },
  cryptoBalanceAlertsSecondForm: {
    marginLeft: 50
  },
  vertSeparator: {
    width: 1,
    height: '100%',
    borderRight: [[1, 'solid', 'black']]
  }
}
